import { render, staticRenderFns } from "./specialCatalogue.vue?vue&type=template&id=0b9ffa1e&scoped=true"
import script from "./specialCatalogue.vue?vue&type=script&lang=js"
export * from "./specialCatalogue.vue?vue&type=script&lang=js"
import style0 from "./specialCatalogue.vue?vue&type=style&index=0&id=0b9ffa1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9ffa1e",
  null
  
)

export default component.exports